import { EnumZboStavPripadu, EnumZboTypPripadu } from '../api';
export const enumZboStavPripadu = Object.keys(EnumZboStavPripadu);
export const getEnumZboStavPripaduCaption = (typ) => {
    switch (typ) {
        case EnumZboStavPripadu.NOVY:
            return 'Nová';
        case EnumZboStavPripadu.NOVY_NACTENO:
            return 'Načten agend. sys.';
        case EnumZboStavPripadu.ZPRACOVAVANO:
            return 'Rozpracováno';
        case EnumZboStavPripadu.PRERUSENO:
            return 'Přerušeno';
        case EnumZboStavPripadu.PRERUSENO_VYZVA:
            return 'Výzva k doplnění';
        case EnumZboStavPripadu.PREDAVANO_HOM:
            return 'Předáváno na HOM';
        case EnumZboStavPripadu.PREVZATO_HOM:
            return 'Převzato z TSK';
        case EnumZboStavPripadu.PREDAVANO_TSK:
            return 'Předáváno na TSK';
        case EnumZboStavPripadu.PREVZATO_TSK:
            return 'Převzato AIS TSK';
        case EnumZboStavPripadu.K_PODPISU:
            return 'Čeká na podpis';
        case EnumZboStavPripadu.ZAMITNUTA:
            return 'Žádost zamítnuta';
        case EnumZboStavPripadu.ZNEPLATNENA:
            return 'Žádost zneplatněna';
        case EnumZboStavPripadu.NEVYJADRUJI_SE:
            return 'Bez vyjádření';
        case EnumZboStavPripadu.VYRIZENA_KLADNE:
            return 'Vyřízeno kladně';
        case EnumZboStavPripadu.VYRIZENA_NEGATIVNE:
            return 'Vyřízeno negativně';
        case EnumZboStavPripadu.PREDANO_MIMO_SYSTEM:
            return 'Předáno mimo systém';
        case EnumZboStavPripadu.ZUK_PREDBEZNE_PROJEDNANO:
            return 'Předběžně projednáno';
        case EnumZboStavPripadu.ZPRACOVANI_OPP:
            return 'Čeká na stan. OPP';
        case EnumZboStavPripadu.ZPRACOVANI_SMLOUVA:
            return 'Čeká na smlouvu';
        case EnumZboStavPripadu.ZPRACOVANI_PREDBEZ_ZUK:
            return 'Čeká na předběžné st.';
        case EnumZboStavPripadu.ZPRACOVANI_SAMSTAN:
            return 'Čeká na samosprávné st.';
        case EnumZboStavPripadu.ZPRACOVANI_KOMISE:
            return 'Čeká na stan. komise';
        case EnumZboStavPripadu.ZPRACOVANI_ZUK:
            return 'Čeká na povol. ZUK';
        case EnumZboStavPripadu.ZPRACOVANI_MIPO:
            return 'Čeká na ohlášení. MIPO';
        default:
            return `_${typ}`;
    }
};
export const getEnumZboStavPripaduItems = () => {
    return enumZboStavPripadu.map(t => ({ id: t, name: getEnumZboStavPripaduCaption(t) })).sort((a, b) => a.name.localeCompare(b.name));
};
import React from 'react';
import { Icon, Tag } from '@mc/ui-v4';
import { mcDropDown } from '@mc/react-ui-icons';
const stavMap = {
    // Technické stavy: světle šedě (silverChalice)
    [EnumZboStavPripadu.PREDAVANO_HOM]: { caption: 'Předáváno na HOM', intent: 'default', color: 'silverChalice', styleColor: '#616161' },
    // Nový: modře, ale jiná barva textu - asi blue (viz SPR má rgb(66, 108, 189))
    [EnumZboStavPripadu.NOVY]: { caption: 'Nová', intent: 'primary', color: 'rgb(66, 108, 189)', styleColor: 'rgb(66, 108, 189)' },
    [EnumZboStavPripadu.NOVY_NACTENO]: { caption: 'Nový (Načteno)', intent: 'primary', color: 'rgb(66, 108, 189)', styleColor: 'rgb(66, 108, 189)' },
    // Ve zpracování: modře standardní barva textu
    [EnumZboStavPripadu.ZPRACOVAVANO]: { caption: 'Rozpracováno', intent: 'default', styleColor: '#3F5785' },
    [EnumZboStavPripadu.PREVZATO_HOM]: {
        caption: 'Převzato z TSK',
        intent: 'default',
        color: 'silverChalice',
        styleColor: '#616161',
        zadostTyp: EnumZboTypPripadu.SMLOUVA,
    },
    [EnumZboStavPripadu.PREDAVANO_TSK]: {
        caption: 'Předáváno na TSK',
        intent: 'default',
        color: 'silverChalice',
        styleColor: '#616161',
        zadostTyp: EnumZboTypPripadu.SMLOUVA,
    },
    [EnumZboStavPripadu.PREVZATO_TSK]: {
        caption: 'Převzato AIS TSK',
        intent: 'default',
        color: 'silverChalice',
        styleColor: '#616161',
        zadostTyp: EnumZboTypPripadu.SMLOUVA,
    },
    // Zpracovává uživatel: magenta
    [EnumZboStavPripadu.PRERUSENO]: { caption: 'Přerušeno', intent: 'default', color: 'magenta', styleColor: '#8A4287' },
    [EnumZboStavPripadu.PRERUSENO_VYZVA]: { caption: 'Výzva k doplnění', intent: 'default', color: 'magenta', styleColor: '#8A4287' },
    [EnumZboStavPripadu.K_PODPISU]: {
        caption: 'Čeká na podpis',
        intent: 'default',
        color: 'magenta',
        styleColor: '#8A4287',
        zadostTyp: EnumZboTypPripadu.SMLOUVA,
    },
    // Ukončeno negativně: červeně
    // [EnumZboStavPripadu.ZAMITNUTA]: { caption: 'Zamítnuto', intent: 'danger', color: 'red' },
    // [EnumZboStavPripadu.ZNEPLATNENA]: { caption: 'Zneplatněno žadatelem', intent: 'danger', color: 'red' },
    [EnumZboStavPripadu.VYRIZENA_NEGATIVNE]: { caption: 'Vyřízeno negativně', intent: 'danger', color: 'red', styleColor: '#CA031F' },
    // Ukončena dílčí část: světle zeleně (olive)
    [EnumZboStavPripadu.ZUK_PREDBEZNE_PROJEDNANO]: {
        caption: 'Předběžně projednáno',
        intent: 'default',
        color: 'olive',
        styleColor: '#4E6D0E',
        zadostTyp: EnumZboTypPripadu.ZUK,
    },
    // Ukončeno kladně: zeleně
    // [EnumZboStavPripadu.VYRIZENA_KLADNE]: { caption: 'Vyřízeno kladně', intent: 'success' },
    // Ukončeno bez nutnosti vyjádření: modrozelená (teal)
    [EnumZboStavPripadu.NEVYJADRUJI_SE]: { caption: 'Bez vyjádření', intent: 'default', color: 'teal', styleColor: '#2E798A' },
    [EnumZboStavPripadu.PREDANO_MIMO_SYSTEM]: { caption: 'Předáno mimo systém', intent: 'default', color: 'teal', styleColor: '#2E798A' },
    // Žádost stavy
    [EnumZboStavPripadu.ZPRACOVANI_OPP]: { caption: 'Čeká na stan. OPP', intent: 'warning' },
    [EnumZboStavPripadu.ZPRACOVANI_SMLOUVA]: { caption: 'Čeká na smlouvu', intent: 'warning' },
    [EnumZboStavPripadu.ZPRACOVANI_PREDBEZ_ZUK]: { caption: 'Čeká na předběžné st.', intent: 'warning' },
    [EnumZboStavPripadu.ZPRACOVANI_SAMSTAN]: { caption: 'Čeká na samosprávné st.', intent: 'warning' },
    [EnumZboStavPripadu.ZPRACOVANI_KOMISE]: { caption: 'Čeká na stan. komise', intent: 'warning' },
    [EnumZboStavPripadu.ZPRACOVANI_ZUK]: { caption: 'Čeká na povol. ZUK', intent: 'warning' },
    [EnumZboStavPripadu.ZPRACOVANI_MIPO]: { caption: 'Čeká na ohlášení. MIPO', intent: 'warning' },
    [EnumZboStavPripadu.VYRIZENA_KLADNE]: { caption: 'Vyřízeno kladně', intent: 'success', styleColor: '#0A8458' },
    [EnumZboStavPripadu.ZAMITNUTA]: { caption: 'Žádost zamítnuta', intent: 'danger', styleColor: '#CA031F' },
    [EnumZboStavPripadu.ZNEPLATNENA]: { caption: 'Žádost zneplatněna', intent: 'default', color: 'magenta', styleColor: '#8A4287' },
};
const EnumZboStavPripaduMap = [
    // EnumZboStavPripadu.NEZALOZEN,
    EnumZboStavPripadu.PREDAVANO_HOM,
    EnumZboStavPripadu.PREDAVANO_TSK,
    EnumZboStavPripadu.NOVY,
    EnumZboStavPripadu.ZPRACOVAVANO,
    EnumZboStavPripadu.PREVZATO_HOM,
    EnumZboStavPripadu.PREVZATO_TSK,
    EnumZboStavPripadu.PRERUSENO,
    EnumZboStavPripadu.PRERUSENO_VYZVA,
    EnumZboStavPripadu.K_PODPISU,
    EnumZboStavPripadu.ZAMITNUTA,
    EnumZboStavPripadu.ZNEPLATNENA,
    EnumZboStavPripadu.VYRIZENA_NEGATIVNE,
    EnumZboStavPripadu.ZUK_PREDBEZNE_PROJEDNANO,
    EnumZboStavPripadu.VYRIZENA_KLADNE,
    EnumZboStavPripadu.NEVYJADRUJI_SE,
    EnumZboStavPripadu.PREDANO_MIMO_SYSTEM,
];
const zadostStavMap = [
    EnumZboStavPripadu.NOVY,
    EnumZboStavPripadu.ZPRACOVANI_OPP,
    EnumZboStavPripadu.ZPRACOVANI_SMLOUVA,
    EnumZboStavPripadu.ZPRACOVANI_PREDBEZ_ZUK,
    EnumZboStavPripadu.ZPRACOVANI_SAMSTAN,
    EnumZboStavPripadu.ZPRACOVANI_KOMISE,
    EnumZboStavPripadu.ZPRACOVANI_ZUK,
    EnumZboStavPripadu.ZPRACOVANI_MIPO,
    EnumZboStavPripadu.VYRIZENA_KLADNE,
    EnumZboStavPripadu.ZAMITNUTA,
    EnumZboStavPripadu.ZNEPLATNENA,
];
export const getStavCaption = (stav) => {
    var _a;
    return ((_a = stavMap[stav]) === null || _a === void 0 ? void 0 : _a.caption) || `Neznámý stav`;
};
export const getStavColor = (stav) => {
    var _a;
    return ((_a = stavMap[stav]) === null || _a === void 0 ? void 0 : _a.color) || 'default';
};
export const getStyleColor = (stav) => {
    var _a;
    return ((_a = stavMap[stav]) === null || _a === void 0 ? void 0 : _a.styleColor) || 'default';
};
export const getStavIntent = (stav) => {
    var _a;
    return (_a = stavMap[stav]) === null || _a === void 0 ? void 0 : _a.intent;
};
export const getZadostStavItems = () => {
    return zadostStavMap.map((t) => ({
        id: t,
        name: getStavCaption(t),
    }));
};
export const EnumZboStavPripaduTag = ({ stav, menu }) => {
    const { intent, color } = stavMap[stav];
    return (React.createElement(Tag, { menu: menu, iconRight: menu && React.createElement(Icon, { icon: mcDropDown }), intent: intent || 'default', color: color || undefined }, getStavCaption(stav)));
};
//# sourceMappingURL=ZboStavPripaduCaption.js.map